import { render, staticRenderFns } from "./SiteBackground.vue?vue&type=template&id=03a93c5d&scoped=true"
import script from "./SiteBackground.vue?vue&type=script&lang=js"
export * from "./SiteBackground.vue?vue&type=script&lang=js"
import style0 from "./SiteBackground.vue?vue&type=style&index=0&id=03a93c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a93c5d",
  null
  
)

export default component.exports